<template>
	<div class="text-center errorpage">
		<div class="error-content">
			<v-img src="@/assets/images/error-image.svg" max-width="300" class="mx-auto"/>
			<h1 class="error-code mt-5">{{ code }}</h1>
			{{ message }}
			<div v-if="url" class="mt-5">
				<v-btn :to="url || '/'" color="accent">{{ title }}</v-btn>
			</div>
		</div>
		
	</div>
</template>
<script>
export default {
	props: {
		code: {
			type: [Boolean, String, Number],
		},
		message: {
			type: String,
			default: "Wystąpił błąd"
		},
		url: {
			type: [String, Object],
			default: '/'
		},
		urlTitle: {
			type: String,
		}
	},
	watch: {
		'$route.fullPath': function() {
			this.$store.commit('application/clearError')
		}
	},
	computed: {
		title() {
			if(this.urlTitle) {
				return this.urlTitle;
			}
			return this.$vuetify.lang.t('$vuetify.home')
		}
		
	},
}
</script>

<style lang="scss">
	.errorpage {
		position: fixed;
		width: 100vw;
		height: calc(100vh - 120px);
		top: 75px;
		left: 0;
		background: var(--v-background-base);
		z-index: 2;
		.error-content {
			margin-top: 100px
		}
		.error-code {
			font-size: 42px;
			font-weight: 800;
		}
	}
</style>